import NotificationApi from '@apis/notification/NotificationApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetNotificationsParams } from '@models/notification';

const notificationQueries = createQueryKeys('notifications', {
  list: (params: GetNotificationsParams) => ({
    queryKey: ['list', params],
    queryFn: () => NotificationApi.getNotifications(params),
  }),
  unread: () => ({
    queryKey: ['unread'],
    queryFn: () => NotificationApi.getHasUnread(),
  }),
});

export default notificationQueries;
